import { TABLE_CELL_PADDING_LEFT, TABLE_CELL_PADDING_RIGHT } from "@/pages/home/_config/config"
import { getLocale, useIntl } from "umi"
import { getMonetUnit } from "./moneyUnit"

const getMetricColumn = () => {
  const { formatMessage } = useIntl()
  const locale = getLocale()
  // 宽表指标列宽度设置
  // 数字代表位数 (不包含逗号, 百分号, 包含小数点)
  // 位数与列名长度 不等时, 取较长的宽度
  const columnWidth = {
    twentyFour: 300 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
    twentyThree: 290 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
    twentyTwo: 280 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
    twentyOne: 270 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
    twenty: 260 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
    nineteen: 250 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
    eighteen: 240 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
    seventeen: 230 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
    sixteen: 220 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
    fifteen: 210 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
    thirteen: 200 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
    twelve: 190 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
    ten: 180 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
    nine: 170 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
    eight: 160 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
    seven: 152 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
    six: 150 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
    five: 145 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
    four: 115 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
  }
  const upDownWidth = 75

  const METRIC_COLUMN = {
    // 指标
    'total_users': {
      width: columnWidth.ten,
      onlyValueWidth: locale === 'en-US' ? columnWidth.ten - upDownWidth : 152,
      name: formatMessage({ id: 'overview_TRU' }),
      isUserType: true,
    },
    'new_users': {
      width: columnWidth.eight,
      onlyValueWidth: columnWidth.eight - upDownWidth,
      name: formatMessage({ id: 'overview_New' }),
      isUserType: true,
    },
    'active_users': {
      width: columnWidth.eight,
      onlyValueWidth: columnWidth.eight - upDownWidth,
      name: formatMessage({ id: 'overview_daily_DAU' }),
      isUserType: true,
    },
    'pay_amount': {
      width: columnWidth.twelve,
      onlyValueWidth: columnWidth.twelve - upDownWidth,
      name: formatMessage({ id: 'overview_Revenue($)' }, { unit: getMonetUnit() }),
    },
    'pcu': {
      width: columnWidth.seven,
      onlyValueWidth: locale === 'en-US' ? columnWidth.seven - upDownWidth : 152,
      name: formatMessage({ id: 'overview_PCU' }),
      isUserType: true,
      dodDecimals: 1,
    },
    'acu': {
      width: columnWidth.seven,
      onlyValueWidth: locale === 'en-US' ? columnWidth.seven - upDownWidth : 152,
      name: formatMessage({ id: 'overview_ACU' }),
      isUserType: true,
      dodDecimals: 1,
    },
    'aot': {
      width: columnWidth.eight,
      onlyValueWidth: locale === 'en-US' ? 204 : columnWidth.twelve,
      name: formatMessage({ id: 'overview_AOT(min)' }),
      dodDecimals: 1,
    },
    'saot': {
      width: columnWidth.eight,
      onlyValueWidth: locale === 'en-US' ? 264 : columnWidth.twelve,
      name: formatMessage({ id: 'overview_Avg_Daily_Playtime(min)' }),
      dodDecimals: 1,
    },
    'paid_users': {
      width: columnWidth.six,
      onlyValueWidth: locale === 'en-US' ? 104 : 120,
      name: formatMessage({ id: 'overview_Payer' }),
      isUserType: true,
      dodDecimals: 1,
    },
    'payer_rate': {
      width: columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? 116 : 136,
      name: formatMessage({ id: 'overview_Payer%' }),
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'arpu': {
      width: locale === 'en-US' ? columnWidth.five : 166,
      onlyValueWidth: locale === 'en-US' ? 136 : 166,
      name: formatMessage({ id: 'overview_ARPU($)' }, { unit: getMonetUnit() }),
      dodDecimals: 1,
    },
    'arppu': {
      width: columnWidth.seven,
      onlyValueWidth: locale === 'en-US' ? 146 : 176,
      name: formatMessage({ id: 'overview_ARPPU($)' }, { unit: getMonetUnit() }),
      dodDecimals: 1,
    },
    'new_paid_users': {
      width: locale === 'en-US' ? columnWidth.eight : columnWidth.eight,
      onlyValueWidth: locale === 'en-US' ? 184 : 166,
      name: formatMessage({ id: 'overview_New_Payer' }),
      isUserType: true,
      dodDecimals: 1,
    },
    'new_pay_amount': {
      width: locale === 'en-US' ? 260 : columnWidth.fifteen,
      onlyValueWidth: locale === 'en-US' ? 260 : 205,
      name: formatMessage({ id: 'overview_Revenue(new_payer)' }),
      dodDecimals: 1,
    },
    'new_arppu': {
      width: locale === 'en-US' ? columnWidth.eighteen : columnWidth.thirteen, // 需要取列长
      onlyValueWidth: locale === 'en-US' ? columnWidth.eighteen : columnWidth.thirteen,
      name: formatMessage({ id: 'overview_New_Users_ARPPU($)' }, { unit: getMonetUnit() }),
      dodDecimals: 1,
    },
    'alc': {
      width: locale === 'en-US' ? 200 : 180,
      onlyValueWidth: locale === 'en-US' ? 200 : 180,
      name: formatMessage({ id: 'overview_Avg.Login_Count' }),
      dodDecimals: 1,
    },
    'retention_users': {
      width: locale === 'en-US' ? 230 : columnWidth.twelve,
      onlyValueWidth: locale === 'en-US' ? 240 : 211,
      name: formatMessage({ id: 'overview_daily_DAU_Retention_Users' }),
      isUserType: true,
      dodDecimals: 1,
    },
    'churn_users': {
      width: columnWidth.nine,
      onlyValueWidth: locale === 'en-US' ? 154 : columnWidth.nine - upDownWidth,
      name: formatMessage({ id: 'overview_daily_Churn_Users' }),
      isUserType: true,
      dodDecimals: 1,
    },
    'churn_rate': {
      width: columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? 120 : 104,
      name: formatMessage({ id: 'overview_Churn%' }),
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'return_users': {
      width: locale === 'en-US' ? columnWidth.ten : columnWidth.nine,
      onlyValueWidth: locale === 'en-US' ? 210 : columnWidth.nine - upDownWidth,
      name: formatMessage({ id: 'overview_daily_DAU_Return_Users' }),
      isUserType: true,
      dodDecimals: 1,
    },
    'first_login_ratio': {
      width: locale === 'en-US' ? 200 : columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? 200 : columnWidth.five,
      name: formatMessage({ id: 'overview_daily_1st_Order_Login%' }),
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'second_login_ratio': {
      width: locale === 'en-US' ? 200 : columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? 200 : columnWidth.five,
      name: formatMessage({ id: 'overview_daily_2nd_Order_Login%' }),
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },

    // ua指标
    'install': {
      width: columnWidth.eight,
      onlyValueWidth: columnWidth.ten - upDownWidth,
      header: formatMessage({ id: 'ua_table_Install' }),
      isUserType: true,
    },
    'register': {
      width: columnWidth.eight,
      onlyValueWidth: columnWidth.ten - upDownWidth,
      header: formatMessage({ id: 'ua_Register' }),
      isUserType: true,
    },
    'install_register_rate': {
      width: columnWidth.sixteen,
      onlyValueWidth: columnWidth.nineteen - upDownWidth,
      name: formatMessage({ id: 'ua_Cohort_Register' }),
      isPercent: true,
      decimals: 2,
    },
    'spend': {
      width: columnWidth.ten,
      onlyValueWidth: columnWidth.twelve - upDownWidth,
      name: formatMessage({ id: 'ua_table_spend' }, { unit: getMonetUnit() }),
      isUserType: true,
    },
    'cpi': {
      width: columnWidth.eight,
      onlyValueWidth: locale === 'en-US' ? columnWidth.eight - upDownWidth : columnWidth.thirteen - upDownWidth,
      name: formatMessage({ id: 'ua_table_cpi' }, { unit: getMonetUnit() }),
      isUserType: true,
    },
    'cpa': {
      width: columnWidth.eight,
      onlyValueWidth: locale === 'en-US' ? columnWidth.eight - upDownWidth : columnWidth.thirteen - upDownWidth,
      name: formatMessage({ id: 'ua_table_cpa' }, { unit: getMonetUnit() }),
      isUserType: true,
    },
    'roas': {
      width: columnWidth.six,
      onlyValueWidth: locale === 'en-US' ? columnWidth.six - upDownWidth : columnWidth.thirteen - upDownWidth,
      name: formatMessage({ id: 'ua_table_ROAS' }),
      isPercent: true,
      decimals: 2,
    },
    'roas_d1': {
      width: columnWidth.six,
      onlyValueWidth: locale === 'en-US' ? columnWidth.nine - upDownWidth : columnWidth.eighteen - upDownWidth,
      name: formatMessage({ id: 'ua_table_roasd1' }),
      isPercent: true,
      decimals: 2,
    },
    'roas_d3': {
      width: columnWidth.six,
      onlyValueWidth: locale === 'en-US' ? columnWidth.nine - upDownWidth : columnWidth.eighteen - upDownWidth,
      name: formatMessage({ id: 'ua_table_roasd3' }),
      isPercent: true,
      decimals: 2,
    },
    'roas_d7': {
      width: columnWidth.six,
      onlyValueWidth: locale === 'en-US' ? columnWidth.nine - upDownWidth : columnWidth.eighteen - upDownWidth,
      name: formatMessage({ id: 'ua_table_roasd7' }),
      isPercent: true,
      decimals: 2,
    },
    'ltv1': {
      width: columnWidth.eight,
      onlyValueWidth: columnWidth.eight - upDownWidth,
      name: formatMessage({ id: 'ua_LTV1' }),
      isUserType: true,
    },
    'ltv3': {
      width: columnWidth.eight,
      onlyValueWidth: columnWidth.eight - upDownWidth,
      name: formatMessage({ id: 'ua_LTV3' }),
      isUserType: true,
    },
    'ltv7': {
      width: columnWidth.eight,
      onlyValueWidth: columnWidth.eight - upDownWidth,
      name: formatMessage({ id: 'ua_LTV7' }),
      isUserType: true,
    },
    'ltv14': {
      width: columnWidth.eight,
      onlyValueWidth: columnWidth.eight - upDownWidth,
      name: formatMessage({ id: 'ua_LTV14' }),
      isUserType: true,
    },
    'ltv30': {
      width: columnWidth.eight,
      onlyValueWidth: columnWidth.eight - upDownWidth,
      name: formatMessage({ id: 'ua_LTV30' }),
      isUserType: true,
    },
    'ltv180': {
      width: columnWidth.eight,
      onlyValueWidth: locale === 'en-US' ? columnWidth.eight - upDownWidth : columnWidth.ten - upDownWidth,
      name: formatMessage({ id: 'ua_LTV180' }),
      isUserType: true,
    },

    // 日粒度
    'd1': {
      width: columnWidth.five,
      onlyValueWidth: columnWidth.five - upDownWidth,
      name: formatMessage({ id: 'overview_daily_D2' }),
      isPercent: true,
      decimals: 2,
    },
    'd2': {
      width: columnWidth.five,
      onlyValueWidth: columnWidth.five - upDownWidth,
      name: formatMessage({ id: 'overview_daily_D2' }),
      isPercent: true,
      decimals: 2,
    },
    'd3': {
      width: columnWidth.five,
      onlyValueWidth: columnWidth.five - upDownWidth,
      name: formatMessage({ id: 'overview_daily_D3' }),
      isPercent: true,
      decimals: 2,
    },
    'd4': {
      width: columnWidth.five,
      onlyValueWidth: columnWidth.five - upDownWidth,
      name: formatMessage({ id: 'overview_daily_D4' }),
      isPercent: true,
      decimals: 2,
    },
    'd5': {
      width: columnWidth.five,
      onlyValueWidth: columnWidth.five - upDownWidth,
      name: formatMessage({ id: 'overview_daily_D5' }),
      isPercent: true,
      decimals: 2,
    },
    'd6': {
      width: columnWidth.five,
      onlyValueWidth: columnWidth.five - upDownWidth,
      name: formatMessage({ id: 'overview_daily_D6' }),
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'd7': {
      width: columnWidth.five,
      onlyValueWidth: columnWidth.five - upDownWidth,
      name: formatMessage({ id: 'overview_daily_D7' }),
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'd14': {
      width: columnWidth.five,
      onlyValueWidth: columnWidth.five - upDownWidth,
      name: formatMessage({ id: 'overview_daily_D14' }),
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'd30': {
      width: columnWidth.five,
      onlyValueWidth: columnWidth.five - upDownWidth,
      name: formatMessage({ id: 'overview_daily_D30' }),
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'weighted_d2': {
      width: columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? 162 : 120,
      name: formatMessage({ id: 'overview_daily_Weighted_D2' }),
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'weighted_d3': {
      width: columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? 160 : 118,
      name: formatMessage({ id: 'overview_daily_Weighted_D3' }),
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'weighted_d7': {
      width: columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? 162 : 118,
      name: formatMessage({ id: 'overview_daily_Weighted_D7' }),
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'weighted_d14': {
      width: columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? 172 : 122,
      name: formatMessage({ id: 'overview_daily_Weighted_D14' }),
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    // 周粒度
    'avg_new_users': {
      width: locale === 'en-US' ? columnWidth.seven : columnWidth.seven + 15,
      onlyValueWidth: locale === 'en-US' ? 176 : 200,
      name: formatMessage({ id: 'overview_weekly_Avg.Daily_New' }),
      isUserType: true,
      dodDecimals: 1,
    },
    'avg_active_users': {
      width: columnWidth.eight,
      onlyValueWidth: locale === 'en-US' ? 190 : 160,
      name: formatMessage({ id: 'overview_weekly_Week_Avg.DAU' }),
      isUserType: true,
      dodDecimals: 1,
    },
    'avg_pay_amount': {
      width: locale === 'en-US' ? 232 : columnWidth.ten,
      onlyValueWidth: locale === 'en-US' ? 240 : 190,
      name: formatMessage({ id: 'overview_weekly_Week_Avg.Revenue($)' }, { unit: getMonetUnit() }),
      dodDecimals: 1,
    },
    'w2': {
      width: columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? columnWidth.five - upDownWidth : 120,
      name: formatMessage({ id: 'overview_weekly_W2' }),
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'w3': {
      width: columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? columnWidth.five - upDownWidth : 114,
      name: formatMessage({ id: 'overview_weekly_W3' }),
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'w4': {
      width: columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? columnWidth.five - upDownWidth : 114,
      name: formatMessage({ id: 'overview_weekly_W4' }),
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'weighted_w2': {
      width: locale === 'en-US' ? columnWidth.six : columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? 166 : 152,
      name: formatMessage({ id: 'overview_weekly_Weighted_W2' }),
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'weighted_w3': {
      width: locale === 'en-US' ? columnWidth.six : columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? 166 : 146,
      name: formatMessage({ id: 'overview_weekly_Weighted_W3' }),
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'weighted_w4': {
      width: locale === 'en-US' ? columnWidth.six : columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? 166 : 146,
      name: formatMessage({ id: 'overview_weekly_Weighted_W4' }),
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    // 月粒度
    'm2': {
      width: columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? columnWidth.five - upDownWidth : 120,
      name: formatMessage({ id: 'overview_monthly_Month_M2' }),
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'm3': {
      width: columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? columnWidth.five - upDownWidth : 114,
      name: formatMessage({ id: 'overview_monthly_Month_M3' }),
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'm4': {
      width: columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? columnWidth.five - upDownWidth : 114,
      name: formatMessage({ id: 'overview_monthly_Month_M4' }),
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'weighted_m2': {
      width: locale === 'en-US' ? columnWidth.six : columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? 166 : 152,
      name: formatMessage({ id: 'overview_monthly_Weighted_M2' }),
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'weighted_m3': {
      width: locale === 'en-US' ? columnWidth.six : columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? 166 : 146,
      name: formatMessage({ id: 'overview_monthly_Weighted_M3' }),
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'weighted_m4': {
      width: locale === 'en-US' ? columnWidth.six : columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? 166 : 146,
      name: formatMessage({ id: 'overview_monthly_Weighted_M4' }),
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    // pc、console游戏指标
    // 'all_entitlement': {
    //   index: 0,
    //   width: columnWidth.twelve,
    //   onlyValueWidth: locale === 'en-US' ? columnWidth.twelve - upDownWidth : 180,
    //   name: formatMessage({ id: 'pc_overview_Entitlement' }),
    //   isUserType: true,
    // },
    'units_number': {
      index: 5,
      width: columnWidth.seventeen,
      onlyValueWidth: columnWidth.seventeen - upDownWidth,
      name: formatMessage({ id: 'pc_overview_Units' }),
      isUserType: true,
    },
    'units_revenue': {
      index: 6,
      width: columnWidth.twenty,
      onlyValueWidth: columnWidth.twenty - upDownWidth,
      name: formatMessage({ id: 'pc_overview_Units_Revenue' }),
      dodDecimals: 1,
    },
    'dlc_revenue': {
      index: 7,
      width: columnWidth.thirteen,
      onlyValueWidth: locale === 'en-US' ? columnWidth.thirteen - upDownWidth : 152,
      name: formatMessage({ id: 'pc_overview_DLC_Revenue' }),
      dodDecimals: 1,
    },
    'mtx_revenue': {
      index: 8,
      width: columnWidth.fifteen,
      onlyValueWidth: locale === 'en-US' ? columnWidth.fifteen - upDownWidth : 152,
      name: formatMessage({ id: 'pc_overview_MTX_Revenue' }),
      dodDecimals: 1,
    },
    'mtx_number': {
      index: 11,
      width: columnWidth.ten,
      onlyValueWidth: locale === 'en-US' ? columnWidth.eight - upDownWidth : 152,
      name: formatMessage({ id: 'pc_overview_MTX' }),
      isUserType: true,
      decimals: 0,
    },
    'mtx_payers': {
      index: 14,
      width: columnWidth.twelve,
      onlyValueWidth: locale === 'en-US' ? columnWidth.twelve - upDownWidth : 152,
      name: formatMessage({ id: 'pc_overview_MTX_Payer' }),
      isUserType: true,
    },
    'mtx_payer_rate': {
      index: 15,
      width: columnWidth.thirteen,
      onlyValueWidth: locale === 'en-US' ? columnWidth.thirteen - upDownWidth : 190,
      name: formatMessage({ id: 'pc_overview_MTX_Payer_Rate' }),
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'mtx_dlc_arpu': {
      index: 16,
      width: columnWidth.eighteen,
      onlyValueWidth: locale === 'en-US' ? columnWidth.eighteen - upDownWidth : 210,
      name: formatMessage({ id: 'pc_overview_DLC_MTX_ARPU' }),
      dodDecimals: 1,
    },
    'mtx_arpu': {
      index: 17,
      width: columnWidth.ten,
      onlyValueWidth: locale === 'en-US' ? columnWidth.ten - upDownWidth : 152,
      name: formatMessage({ id: 'pc_overview_MTX_ARPU' }),
      dodDecimals: 1,
    },
    'mtx_dlc_arppu': {
      index: 18,
      width: columnWidth.nineteen,
      onlyValueWidth: locale === 'en-US' ? columnWidth.nineteen - upDownWidth : 240,
      name: formatMessage({ id: 'pc_overview_DLC_MTX_ARPPU' }),
      dodDecimals: 1,
    },
    'mtx_arppu': {
      index: 19,
      width: columnWidth.twelve,
      onlyValueWidth: locale === 'en-US' ? columnWidth.twelve - upDownWidth : 190,
      name: formatMessage({ id: 'pc_overview_MTX_ARPPU' }),
      dodDecimals: 1,
    },
    'digital_revenue': {
      index: 20,
      width: columnWidth.seventeen,
      onlyValueWidth: locale === 'en-US' ? columnWidth.seventeen - upDownWidth : 152,
      name: formatMessage({ id: 'pc_overview_Digital_Revenue' }),
      dodDecimals: 1,
    },
    'physical_revenue': {
      index: 21,
      width: columnWidth.seventeen,
      onlyValueWidth: locale === 'en-US' ? columnWidth.seventeen - upDownWidth : 152,
      name: formatMessage({ id: 'pc_overview_Physical_Revenue' }),
      dodDecimals: 1,
    },
    'avg_time_to_purchase': {
      index: 22,
      width: columnWidth.twentyThree,
      onlyValueWidth: locale === 'en-US' ? columnWidth.twentyThree - upDownWidth : 190,
      name: formatMessage({ id: 'pc_overview_Time_to_Purchase' }),
      decimals: 2,
      dodDecimals: 1,
    },
  }
  return METRIC_COLUMN
}

export default getMetricColumn
